import React from 'react';

export default ({ className }) => (
  <svg className={className} viewBox='0 0 30 27' fill='none'>
    <g>
      <g>
        <g>
          <path
            fill='currentColor'
            d='M24.3,15H5.7c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3h18.5c0.7,0,1.3,0.6,1.3,1.3C25.6,14.4,25,15,24.3,15z'
          />
        </g>
        <g>
          <path
            fill='currentColor'
            d='M24.3,21H5.7c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3h18.5c0.7,0,1.3,0.6,1.3,1.3C25.6,20.4,25,21,24.3,21z'
          />
        </g>
        <g>
          <path
            fill='currentColor'
            d='M24.3,27H5.7c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3h18.5c0.7,0,1.3,0.6,1.3,1.3C25.6,26.4,25,27,24.3,27z'
          />
        </g>
      </g>
      <path
        fill='currentColor'
        d='M29.5,11.1L25.2,8V1.6c0-0.6-0.4-1-1-1h-4.2c-0.5,0-1,0.4-1,1l0,1.8l-4.1-3L0.5,11.1c-0.5,0.4-0.7,1.2-0.3,1.7
		s1.2,0.7,1.7,0.3L15,3.5l13.1,9.6c0.2,0.2,0.5,0.2,0.7,0.2c0.4,0,0.8-0.2,1-0.5C30.2,12.3,30,11.5,29.5,11.1z'
      />
    </g>
  </svg>
);
